import { render, staticRenderFns } from "./OptionToggle.vue?vue&type=template&id=4a17de1a&scoped=true&"
import script from "./OptionToggle.vue?vue&type=script&lang=ts&"
export * from "./OptionToggle.vue?vue&type=script&lang=ts&"
import style0 from "./OptionToggle.vue?vue&type=style&index=0&id=4a17de1a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a17de1a",
  null
  
)

export default component.exports